import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const SMALL_ELECTRIC_VEHICLE = {
  nickname: 'PRODUCTS.SMALL_ELECTRIC_VEHICLE.shortname',
  properties: [
    { name: 'make', key: 'MAKE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'driverBirthYear', key: 'DRIVER_BIRTH_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },

    { name: 'serialNumber', key: 'SERIAL_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'vehicleType', key: 'VEHICLE_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.ELECTRIC_SCOOTER', value: 'ELECTRIC_SCOOTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.STANDING_BIKE_WITH_HANDLEBARS', value: 'STANDING_BIKE_WITH_HANDLEBARS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.STANDING_BIKE_WITHOUT_HANDLEBARS', value: 'STANDING_BIKE_WITHOUT_HANDLEBARS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.SINGLE_WHEEL_STANDING_BIKE', value: 'SINGLE_WHEEL_STANDING_BIKE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.ELECTRIC_LONGBOARD', value: 'ELECTRIC_LONGBOARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.OTHER', value: 'OTHER' },
        ]
      }
    },
  ],
  icon:'small-electric-vehicle'
};
